import styled from 'styled-components';

export const Container = styled.div`
  & .react-flow__pane,
  & .react-flow__edge {
    cursor: default;
  }
`;

export const InspectorContainer = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 999;
  padding: 0;
`;
